import React from 'react'
import './style.css'

export const SectionCardWrapper = (props) => {
    const { children } = props
    return (
        <div className="card">
            {children}
        </div>
    )

}